import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Grid, Typography } from '@mui/material';
import headerLogo from "../assets/Receipt-ec-logo.png"
import Header from "../assets/Receipt-header.png"
import Footer from "../assets/Receipt-footer.png"
import CancelIcon from '@mui/icons-material/Cancel';

interface Transaction {
    loanAccountNo: string;
    invoiceNo: string;
    amount: string;
    quickPay: string;
    paymentDate: string;
    receiptNo: string;
    authCode: string;
    paymentStatus: string;
}

const gridStyle = {
    display: 'flex',
    flexDirection: 'column',
    background: '#FFF',
    width: '750px',
    height: '750px',
    minHeight: '931px',
    mx: 'auto',
};

const containerStyle = {
    backgroundImage: `url(${Header})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    position: 'relative',
};

const imageStyle = {
    width: '100%',
    height: 'auto',
};
const TransactionReceiptSuccess: React.FC<{ transaction: Transaction | null }> = ({ transaction }) => {
    return (
        <Grid
            sx={gridStyle}>
            <Box
                sx={{
                    position: 'absolute' as 'absolute',
                    top: '0',
                    left: '100%',
                    transform: 'translate(550%,-5%)',
                    width: 50,
                    p: 4,
                    color: 'white'
                }}
            >
                <CancelIcon fontSize='large' />
            </Box>
            <Grid item sx={containerStyle}>
                <Box sx={{ width: '250px', p: 4, marginLeft: 'auto' }}>
                    <img src={headerLogo} alt="" />
                    <span style={{ display: 'block', textAlign: 'center', marginTop: '8px' }}>
                        {/* <span style={{ fontWeight: 'bolder' }}>Merchant:</span> YAAS Installments Credit Facilities Co. WLL */}
                        <span style={{ fontWeight: 'bolder', fontSize: 11 }}>YAAS Installments Credit Facilities Co. WLL</span>
                    </span>
                </Box>
            </Grid>
            <Grid item xs={12}  >
                <Grid display='flex' flexDirection='row' justifyContent="space-between" sx={{ mx: 7, marginTop: '20px' }}>
                    <Grid sx={{ textAlign: 'left' }}>
                        <Typography sx={{ fontSize: 14 }} color="black" gutterBottom>
                            Receipt To:
                        </Typography>
                        <Typography sx={{ fontSize: 16, fontWeight: 'bolder' }} color="black" gutterBottom>
                            Adnan Ahmed
                        </Typography>
                        {/* <Typography sx={{ fontSize: 14 }} color="black" gutterBottom>
                            1234 Block A, Street 567
                            Hawalli
                            12345
                            Kuwait
                        </Typography> */}
                        <Typography sx={{ fontSize: 14 }} color="black" gutterBottom>
                            +91-8745834587
                        </Typography>
                        <Typography sx={{ fontSize: 16, fontWeight: 'bolder' }} color="#055D9C" gutterBottom>
                            Civil ID : 987654321000
                        </Typography>
                    </Grid>
                    <Grid display='flex' flexDirection='row' justifyContent="space-around" gap={2} sx={{ height: '20px' }}>
                        <Typography sx={{ fontSize: 14, color: 'black' }} color="text.secondary" gutterBottom>
                            Invoice :  43545342
                        </Typography>
                        <Typography sx={{ fontSize: 14, color: 'black' }} color="text.secondary" gutterBottom>
                            Date : 05/12/2023
                        </Typography>
                    </Grid>
                </Grid>
                <Grid display='flex' justifyContent='center' flexDirection="column" alignItems='center' sx={{ p: 2, mt: 5 }}>
                    <TableContainer sx={{ width: '650px', mt: 1, border: 'none', boxShadow: 'none' }} component={Paper}>
                        <Table sx={{ minWidth: 650, border: 'none', boxShadow: 'none' }} aria-label="simple table">
                            <TableHead className='headTextColor' style={{ background: '#055D9C', borderRadius: '50px', width: '650px' }}>
                                <TableRow style={{ borderRadius: '50px' }}>
                                    <TableCell align="center">Installment No.</TableCell>
                                    <TableCell align="center">Account No.</TableCell>
                                    <TableCell align="center">Installment Amount</TableCell>
                                    <TableCell align="center">Total Amount</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody sx={{ border: 'none', boxShadow: 'none' }}>
                                <TableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell align="center" component="th" scope="row">12</TableCell>
                                    <TableCell align="center">23</TableCell>
                                    <TableCell align="center">257.465 KWD</TableCell>
                                    <TableCell align="center">267.465 KWD</TableCell>
                                </TableRow>
                                <TableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell align="center" component="th" scope="row">12</TableCell>
                                    <TableCell align="center">23</TableCell>
                                    <TableCell align="center">257.465 KWD</TableCell>
                                    <TableCell align="center">267.465 KWD</TableCell>
                                </TableRow>
                                <TableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell align="center" component="th" scope="row">12</TableCell>
                                    <TableCell align="center">23</TableCell>
                                    <TableCell align="center">257.465 KWD</TableCell>
                                    <TableCell align="center">267.465 KWD</TableCell>
                                </TableRow>
                                <TableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell align="center" component="th" scope="row">12</TableCell>
                                    <TableCell align="center">23</TableCell>
                                    <TableCell align="center">257.465 KWD</TableCell>
                                    <TableCell align="center">267.465 KWD</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <div style={{ width: '650px' }} >
                        <Box sx={{ width: '282px', marginLeft: 'auto', mt: 2 }} >
                            <Table className='insTable' size="small" aria-label="a dense table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '16px', color: '#0067B2', fontWeight: 'bold' }} align="left">Subtotal</TableCell>
                                        <TableCell sx={{ fontSize: '16px', color: '#00104B', fontWeight: '600' }} align="center">
                                            {/* <KuwaitiDinarFormat amount={subTotalAmount} /> */} 26.98 KWD
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '16px', color: '#0067B2', fontWeight: 'bold' }} align="left">Charges</TableCell>
                                        <TableCell sx={{ fontSize: '16px', color: '#00104B', fontWeight: '600' }} align="center">
                                            {/* <KuwaitiDinarFormat amount={Charges} /> */} 0.00 %
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ fontSize: '16px', color: '#0067B2', fontWeight: 'bold' }} align="left">Total</TableCell>
                                        <TableCell sx={{ fontSize: '16px', color: '#00104B', fontWeight: '600' }} align="center">
                                            {/* <KuwaitiDinarFormat amount={TotalAmount} /> */} 657 KWD
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </div>
                </Grid>
            </Grid>
            <Grid item>
                <img src={Footer} alt="Top Logo" style={imageStyle} />
            </Grid>
        </Grid>
    );
}

export default TransactionReceiptSuccess